import React, { useEffect, useState } from 'react';
import nfllogo from '../Dashboard/img/nfl.png';
import './style.css';

const BreakingNews = ({
  sportID,
  buttonText = 'See More',
  title,
  logo,
  newsItems = [],
  pageSize = 5,
  hasMore: hasMoreProp,
  onLoadMore
}) => {
  const newsLimit = pageSize;
  const [news, setNewsItems] = useState(newsItems);
  const [offset, setOffset] = useState(newsItems.length || 0);
  const [expandedIndex, setExpandedIndex] = useState(null);
  const [hasMore, setHasMore] = useState(Boolean(hasMoreProp));
  const [isLoadingMore, setIsLoadingMore] = useState(false);

  useEffect(() => {
    // When context changes (sport/title), reset local pagination to server-provided initial state.
    setNewsItems(newsItems);
    setOffset(newsItems.length || 0);
    setExpandedIndex(null);
    setHasMore(Boolean(hasMoreProp));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sportID, title]);

  useEffect(() => {
    // Hydrate once when initial data arrives; avoid clobbering appended local state.
    if ((!news || news.length === 0) && Array.isArray(newsItems) && newsItems.length > 0) {
      setNewsItems(newsItems);
      setOffset(newsItems.length);
      setHasMore(Boolean(hasMoreProp));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newsItems, hasMoreProp]);

  const fetchNews = async (currentOffset) => {
    setIsLoadingMore(true);
    try {
      if (typeof onLoadMore === 'function') {
        const result = await onLoadMore({
          offset: currentOffset,
          limit: newsLimit,
          currentItems: news
        });
        const nextItems = Array.isArray(result?.items) ? result.items : [];
        const nextOffset = Number.isFinite(Number(result?.nextOffset)) ? Number(result.nextOffset) : currentOffset + nextItems.length;

        setNewsItems((prev) => [...prev, ...nextItems]);
        setOffset(nextOffset);
        setHasMore(Boolean(result?.hasMore));
        return;
      }

    const response = await fetch('/api/news', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ sportID, limit: newsLimit, offset: currentOffset })
    });
    const data = await response.json();
      const nextItems = Array.isArray(data?.data?.news) ? data.data.news : [];
      setNewsItems((prev) => [...prev, ...nextItems]);
      setOffset(currentOffset + nextItems.length);
      setHasMore(nextItems.length === newsLimit);
    } finally {
      setIsLoadingMore(false);
    }
  };

  const handleSeeMore = async () => {
    if (isLoadingMore) return;
    await fetchNews(offset);
  };

  const handleToggle = (index) => {
    setExpandedIndex(prev => (prev === index ? null : index));
  };

  return (
    <div className="breaking-news">
      <div className="container">
        <div className="nfl-header" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
          <img src={logo} alt="logo" />
          <h4>{title}</h4>
        </div>
        <ul className="news-list collapsed">
          {news.map((item, idx) => {
            const isExpanded = expandedIndex === idx;
            return (
              <li key={idx}>
                <div className={`news-content ${isExpanded ? '' : 'truncated'}`}>
                  {item.Content}
                </div>
                <div className="news-meta">
                  <span className="news-date">
                    {new Date(item.Updated).toLocaleDateString()} • {item.TimeAgo}
                  </span>
                  <button onClick={() => handleToggle(idx)}>
                    {isExpanded ? 'Read Less' : 'Read More'}
                  </button>
                </div>
              </li>
            );
          })}
        </ul>

        {hasMore && news.length > 0 && (
          <button onClick={handleSeeMore} disabled={isLoadingMore}>{isLoadingMore ? 'Loading...' : buttonText}</button>
        )}
      </div>
    </div>
  );
};

export default BreakingNews;
